// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { get, post, ServiceResult } from "@insite/client-framework/Services/ApiService";

const uri = "/api/vmi/cpn";

export const updatePartNumbers = async (parameters: any): Promise<ServiceResult<any>> => {
    try {
        const result = await post(`${uri}/update`, parameters);
        return {
            successful: true,
            result,
        };
    } catch (error) {
        if ("status" in error && error.status === 400 && error.errorJson && error.errorJson.message) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
};

export const getcustomerpartnumbers = async (productIds: any): Promise<any> => {
    const result: any = await get<any>(`${uri}/getcustomerpartnumbers`, {}, { productIds });
    return result;
};
